import * as _ from "lodash";
import { Schema } from "js-data";
import { IKeyGeneratorSpecs } from "./lib/libIF";
import { TableCustomColumnsEntry } from "./PA.Core.IF.Entity";
import { PAEnvironment } from "./PAEnvironment";
import {
    WB_ScnConstraint,
    WB_ScnPlannerCalc,
    WB_ScnPlannerCalcLog,
    WB_ScnPlannerCnstr,
    WB_ScnPlannerCR,
    WB_ScnPlannerESR,
    WB_ScnPlannerPPR,
    WB_ScnPlannerPR,
    WB_ScnPlannerPrdPPR,
    WB_ScnPlannerPrdPR,
    WB_ScnPlannerTrial,
    WB_ScnPlannerTrialEvt
} from "./PAdbSchema.PM";

// Entity Sets
// Mapper Schemas and Relationships

// Purge Candidates
/*
export const esWB_Simulation_Type = 'WB_SimulationM'
export const esWB_Simulation_Type_Input_Relationship = 'WB_SimulationM_InputR'
export const esWB_Simulation_Metric = 'WB_Simulation_Mt'

export const esWB_CBO_Predictor_Relationship = 'WB_CBO_PredictorR'
export const esWB_CBO_Predictor_Range = 'WB_CBO_Predictor_Range'
export const esWB_CBO_Predictor_DiscreteSet = 'WB_CBO_PredictorDS'
export const esWB_CBO_Metric = 'WB_CBO_Mt'
export const esWB_CBO_Metric_Predictor = 'WB_CBO_MtPR'
*/

// MDSetBO
export const esWB_MasterData_Set = "WB_MDSet";
export const esWB_Source = "Source";
export const esWB_Source_SetType = "SourceSR";
export const esWB_Set = "Set";

export const esWB_Entity = "WB_Entity";
export const esWB_Entity_AttributeType = "WB_EntityAMR";
export const esWB_AttributeType = "WB_AttributeM";

export const esWB_Division = "WB_Division";
export const esWB_Division_Text = "WB_DivisionT";

export const esWB_DistribChannel = "WB_DistribChannel";
export const esWB_DistribChannel_Text = "WB_DistribChannelT";

export const esWB_Company = "WB_Company";
export const esWB_Company_Text = "WB_CompanyT";

export const esWB_SalesOrg = "WB_SalesOrg";
export const esWB_SalesOrg_Text = "WB_SalesOrgT";

export const esWB_SalesArea = "WB_SalesArea";
export const esWB_SalesArea_Text = "WB_SalesAreaT";

//ApprovalBO
export const esWB_Approval = "WB_Approval";

// CustomerBO
export const esWB_Customer = "WB_Cust";
export const esWB_Customer_Attribute = "WB_CustAttr";
export const esWB_Customer_LogicalKey = "WB_CustLKR";
export const esWB_Customer_Hierarchy = "WB_CustH";
export const esWB_Customer_Hierarchy_SalesArea = "WB_CustHSR";
export const esWB_Customer_Hierarchy_Level = "WB_CustH_Level";
export const esWB_Customer_Relationship = "WB_CustR";
export const esWB_Customer_Tag_Relationship = "WB_Cust_TagR";
export const esWB_Customer_External_Relationship = "WB_ExtCustR";
export const esWB_Customer_Proxy_Relationship = "WB_ExtCustP";
export const esWB_Customer_Calendar = "WB_CustCal";
export const esWB_Customer_Product = "WB_CustPrdR";
export const esWB_Customer_Distribution_Relationship = "WB_CustRPG";
export const esWB_Customer_Role = "WB_Customer_Role";
export const esWB_Customer_Type = "WB_CustM";
export const esWB_Customer_SalesArea_Relationship = "WB_CustomerSR";
export const esWB_Customer_Role_Relationship = "WB_Customer_RSR";
export const esWB_Customer_Role_Customer_Relationship = "WB_CustomerRSCR";
export const esWB_Customer_Hierarchy_Text = "WB_CustHT";
export const esWB_CustomerCR = "WB_CustCR";
export const esWB_CustomerSAR = "WB_CustSAR";

// DataObject BO
export const esWB_DataObject = "WB_DataObject";
export const esWB_DataObject_Text = "WB_DataObjectT";
export const esWB_DataObject_Column = "WB_DataObject_Column";
export const esWB_DataObject_Column_Text = "WB_DataObject_ColumnT";
export const esWB_DataObject_Message = "WB_DataObject_Message";
export const esWB_DataObject_Message_Text = "WB_DataObject_MessageT";

// Staging
export const esWB_Staging = "WB_Staging";
export const esWB_Staging_ClientRaw = "WB_Staging_ClientRaw";
export const esWB_Staging_Archive = "WB_Staging_Archive";

// Circular Config BO
export const esWB_Circular_Config = "WB_Circular_Config";
export const esWB_Circular_ConfigCR = "WB_Circular_ConfigCR";

// Circular BO
export const esWB_Circular_AdBlock = "WB_Circular_AdBlock";
export const esWB_Circular = "WB_Circular";
export const esWB_CircularCR = "WB_CircularCR";
export const esWB_CircularPR = "WB_CircularPR";

// Product BO
export const esWB_Finished_Product = "WB_Prod";
export const esWB_Finished_Product_Text = "WB_ProdT";

export const esWB_Finished_Product_SalesArea = "WB_ProdSR";
export const esWB_Finished_Product_Relationship = "WB_ProdR";
export const esWB_Finished_Product_Tag_Relationship = "WB_Prod_TagR";

// Product Type BO
export const esWB_Product_Type = "WB_PrdM";

// Product BO & Product Group BO
export const esWB_Product_Attribute = "WB_PrdAttr";

// Product Group BO
export const esWB_Product_Group = "WB_PrdGrp";
export const esWB_Product_Group_Text = "WB_PrdGrpT";

export const esWB_Product_Group_SalesArea = "WB_PrdGrpSR";
export const esWB_Product_Group_LogicalKey = "WB_PrdGrpLKR";

export const esWB_Product_Group_Relationship = "WB_PrdGrpR";
export const esWB_Product_Group_Attribute = "WB_PrdGrpAR";
export const esWB_Product_Group_External_Relationship = "WB_PrdGrp_ExtR";
export const esWB_Product_Group_Tag_Relationship = "WB_PrdGrp_TagR";

// Product Hierarchy BO
export const esWB_Product_Hierarchy = "WB_PrdH";
export const esWB_Product_Hierarchy_SalesArea = "WB_PrdHSR";
export const esWB_Product_Hierarchy_Level = "WB_PrdH_Level";
export const esWB_Product_Hierarchy_Text = "WB_PrdHT";

// Product BOM
export const esWB_Product_BOM = "WB_Prod_BOM";
export const esWB_Product_BOM_Component = "WB_PrdBOM_Comp";

// Product UOM
export const esWB_Product_UOM = "WB_Prod_UOM";

// Product Group UOM
export const esWB_Product_Group_UOM = "WB_PrdGrp_UOM";

// UOM
export const esWB_UOM = "WB_UOM";
export const esWB_UOM_Text = "WB_UOMT";

// Consumer Product BO
export const esWB_Consumer_Product_Alignment = "WB_UpcPrdR";
export const esWB_Consumer_Product_Customer_Alignment = "WB_UpcPrdPR";

// Period BO
export const esWB_Period = "WB_Period";
export const esWB_Period_Relationship = "WB_PeriodR";
export const esWB_Period_Tag_Relationship = "WB_Period_TagR";
export const esWB_Period_Type = "WB_PeriodM";
export const esWB_Period_Hierarchy = "WB_PeriodH";
export const esWB_Period_Hierarchy_Level = "WB_PeriodH_Level";
export const esWB_Period_Company_Relationship = "WB_PeriodCR";
export const esWB_Period_Hierarchy_Company_Relationship = "WB_PeriodHCR";
export const esWB_Period_Attribute = "WB_PeriodAttr";

// File BO
export const esWB_File = "WB_File";

// Competitive Group Definition Step

// Domain BO
export const esWB_Domain = "WB_Dom";
export const esWB_Domain_Text = "WB_DomT";
export const esWB_Domain_Item = "WB_DomItem";
export const esWB_Domain_Item_Text = "WB_DomItemT";

// Custom Column BO
export const esWB_Custom_Column = "WB_Custom_Column";

// Affinity Set BO
export const esWB_AffinitySet = "WB_AffinitySet";
export const esWB_AffinityGroup = "WB_AffinityGroup";
export const esWB_AffinityGroupItem = "WB_AffinityGroupItem";

// Product Conditions
export const esWB_Product_Condition = "Prod_Cnd";

// Product Condition Type
export const esWB_Product_Condition_Type = "Prod_CndM";
export const esWB_Product_Condition_Type_Text = "Prod_CndMT";

// Consumption BO
export const esWB_Consumption_Product_Group = "WB_CnsPG";
export const esWB_Consumption_Product = "WB_CnsPrd";

// Spend Allocation Rule
export const esWB_Spend_Allocation_Rule = "WB_SpendRL";
export const esWB_Spend_Allocation_Rule_Item = "WB_SpendRLR";

// Spend Calc Method Rule
export const esWB_Spend_Method_Rule = "WB_SpendClR";

// Meta BO
export const esWB_Meta = "WB_Meta";
export const esWB_Meta_Text = "WB_MetaT";
export const esWB_Meta_Tags = "WB_TagMetaR";

// Tag BO
export const esWB_Tag = "WB_Tag";
export const esWB_Tag_Relationship = "WB_TagR";
export const esWB_Tag_Text = "WB_TagT";
export const esWB_Tag_Metric = "WB_TagMtrcR";

// Tag Source BO
export const esWB_Tag_Source = "WB_Tag_Source";
export const esWB_Tag_Function = "WB_Tag_Function";
export const esWB_Tag_Function_Param = "WB_Tag_Function_Param";

// Tag Rule BO
export const esWB_Tag_Rule = "WB_Tag_Rule";
export const esWB_Tag_Rule_Param = "WB_Tag_Rule_Param";

// Metrics (No BO)
export const esWB_Metric = "WB_Metric";

// Cube Source
export const esWB_CubeSource = "WB_CubeSource";
export const esWB_CubeSource_Dimension = "WB_CubeSourceDR";
export const esWB_CubeSource_DataSource = "WB_CubeSourceDSR";
export const esWB_CubeSource_DataSource_Dimension = "WB_CubeSourceDSDR";

// Plan Group BO
export const esWB_Plan_Group = "WB_PlanGrp";

// Plan BO
export const esWB_Plan = "WB_Plan";
export const esWB_Plan_Product_Group = "WB_PlanPG";
export const esWB_Plan_Product = "WB_PlanPrd";
export const esWB_Plan_Override = "WB_PlanO";

// TPM Plan BO
export const esWB_Plan_Volume_Metrics = "WB_PlanVMt";
export const esWB_Plan_Redistrib_Volume_Metrics = "WB_PlanRVMt";
export const esWB_Plan_Funding_Metrics = "WB_PlanFMt";
export const esWB_Plan_Volume_Monthly_Metrics = "WB_PlanMMt";
export const esWB_Plan_Approval_Metrics = "WB_PlanAMt";
export const esWB_Plan_Product_Metrics = "WB_PlanPrdMt";

// Event BO
export const esWB_Event = "WB_Evt";
export const esWB_EventFR = "WB_EvtFR";
export const esWB_Event_Product_Group = "WB_EvtPG";
export const esWB_Event_Product = "WB_EvtPrd";
export const esWB_Event_Customer = "WB_EvtSCst";
export const esWB_Event_Meta = "WB_EvtMetaR";
export const esWB_Event_Tag = "WB_EvtTagR";
export const esWB_Event_Relationship = "WB_EvtR";
export const esWB_Event_Override = "WB_EvtO";
export const esWB_Event_Product_Group_Override = "WB_EvtPGO";
export const esWB_Event_Spend = "WB_EvtS";
export const esWB_Event_Spend_PrdGrp = "WB_EvtSPG";
export const esWB_Event_Spend_Prd = "WB_EvtSPrd";
export const esWB_Event_Spend_PrdGrp_Customer = "WB_EvtSPGC";
export const esWB_Event_Spend_PrdGrp_Override = "WB_EvtSPGO";
export const esWB_Event_Spend_PrdGrp_Redistrib = "WB_EvtRSPG";
export const esWB_Event_Portfolio = "WB_Evt_Portfolio";
export const esWB_Event_Portfolio_Relationship = "WB_Evt_PortfolioR";
export const esWB_Event_Portfolio_Customer_Relationship = "WB_Evt_PortfolioCR";
export const esWB_Event_Portfolio_Period_Relationship = "WB_Evt_PortfolioTR";
export const esWB_Event_Portfolio_Product_Relationship = "WB_Evt_PortfolioPR";
export const esWB_Event_Portfolio_Tag_Relationship = "WB_Evt_PortfolioTGR";
export const esWB_Event_Portfolio_EventType_Relationship = "WB_Evt_PortfolioETR";
export const esWB_Event_Portfolio_LinkedAnalysis = "WB_Evt_PortfolioLA";
export const esWB_Event_Portfolio_LinkedAnalysis_Relationship = "WB_Evt_PortfolioLAR";
export const esWB_Event_Circular = "WB_EvtCir";
export const esWB_EvtShipPrd = "WB_EvtShipPrd";
export const esWB_EvtShipCPrd = "WB_EvtShipCPrd";
export const esWB_EvtSShpPrd = "WB_EvtSShpPrd";
export const esWB_EvtSShpPrdO = "WB_EvtSShpPrdO";

export const esWB_PEA_Event_Override = "WB_Override";
export const esWB_PEA_Event_ProductGroup_Override = "WB_Override_PrdGrp";
export const esWB_PEA_Event_Spend_Override = "WB_Override_EvtS";
export const esWB_PEA_Event_Spend_ProductGroup_Override = "WB_Override_EvtSPG";

// TPM Event BO
export const esWB_TPM_Event = "WB_TPM_Evt";
export const esWB_TPM_Event_Product_Group = "WB_TPM_EvtPG";
export const esWB_TPM_Event_Product = "WB_TPM_EvtPrd";
export const esWB_TPM_Event_Tag = "WB_TPM_EvtTagR";
export const esWB_TPM_Event_Metrics = "WB_TPM_EvtMtr";

export const esWB_TPM_Event_Spend = "WB_TPM_EvtS";
export const esWB_TPM_Event_Spend_Product_Group = "WB_TPM_EvtSPG";
export const esWB_TPM_Event_Spend_Product = "WB_TPM_EvtSPrd";
export const esWB_TPM_Event_Spend_Metrics = "WB_TPM_EvtSMtr";
export const esWB_TPM_Event_Spend_Customer = "WB_TPM_EvtSCst";
export const esWB_TPM_Event_Product_Metrics = "WB_TPM_EvtPrdMt";

export const esWB_Lift = "WB_Lift";

// TPM Spend Type BO
export const esWB_Event_Spend_Type = "WB_EvtSType";
export const esWB_Event_Spend_Type_Account = "WB_EvtSAcct";
export const esWB_Event_Spend_Type_Relationship = "WB_EvtSTypeR";

// Spend Type BO
export const esWB_Spend_Type = "WB_SpendM";

// Event Accrual
export const esWB_Event_Accrual = "WB_EvtAcr";

// Claim Type BO
export const esWB_Claim_Type = "WB_ClmType";
export const esWB_Claim_Type_Payment_Type = "WB_ClmTypePmtTR";

// Claim BO
export const esWB_Claim = "WB_Clm";
export const esWB_Claim_Plan_Match = "WB_ClmPR";

// Payment Type BO
export const esWB_Payment_Type = "WB_PmtType";

// Payment BO
export const esWB_Payment = "WB_Pmt";
export const esWB_Payment_Event_Spend = "WB_PmtEvtS";
export const esWB_Payment_Event_Spend_Product_Group = "WB_PmtEvtSP";
export const esWB_Payment_Fund = "WB_PmtEvtFnd";
export const esWB_Payment_Fund_Product_Group = "WB_PmtFndP";
export const esWB_Payment_Claim = "WB_PmtClmR";

// Auth Provider BO
export const esWB_Auth_Provider = "WB_AuthPrvd";

// User BO
export const esWB_User = "WB_AuthUsr";
export const esWB_User_Customer = "WB_UsrCustR";
export const esWB_User_Role = "WB_UsrRoleR";
export const esWB_User_Dimension = "WB_UsrDimR";

//User Group
export const esWB_User_Group = "WB_UsrGrp";
export const esWB_User_Group_Customer = "WB_UsrGrpCR";
export const esWB_User_Group_Product = "WB_UsrGrpPR";
export const esWB_User_Group_User = "WB_UsrGrpUR";
export const esWB_User_Group_Role = "WB_UsrGrpRR";
export const esWB_User_Group_Relationship = "WB_UsrGrpR";
export const esWB_User_Group_SalesArea = "WB_UsrGrpSAR";
export const esWB_User_Group_Type = "WB_UsrGrpM";
export const esWB_User_Group_Hierarchy = "WB_UsrGrpH";

// Session BO
export const esWB_Session = "WB_Session";

// Audit Log
export const esWB_Audit_Log = "WB_AuditLog";

// Business Unit
export const esWB_BusinessUnit = "WB_BusinessUnit";
export const esWB_BusinessUnit_Source = "WB_BusinessUnitSource";
export const esWB_BusinessUnit_User = "WB_BusinessUnit_User";

// Pricing Engine Configuration
export const esWB_Pricing_Engine = "WB_Pricing_Engine";
export const esWB_Pricing_Engine_Price_Relationship = "WB_Pricing_Engine_PR";

// Jobs
export const esWB_Job = "WB_Job";
export const esWB_Job_Run = "WB_JobRun";

// Job Trigger
export const esWB_Job_Trigger = "WB_Job_Trigger";

// Job Schedule Process
export const esWB_Job_Schedule_Process = "WB_JobSchedule_Process";

// Job Process
export const esWB_Job_Process = "WB_JobProcess";
export const esWB_Job_Process_Queue = "WB_JobProcessQueue";
export const esWB_Job_Processor = "WB_JobProcessor";
export const esWB_Job_Processor_ConfigR = "WB_JobProcessorConfigR";

export const esWB_Job_Param = "WB_Job_Param";
export const esWB_Job_ParamSR = "WB_Job_ParamSR";

// Batch Process
export const esWB_BatchProcess = "WB_BatchProcess";
export const esWB_BatchScope = "WB_BatchScope";
export const esWB_BatchScopeMR = "WB_BatchScopeMR";
export const esWB_BatchScopeCR = "WB_BatchScopeCR";
export const esWB_BatchScopeSR = "WB_BatchScopeSR";

// Queue Table
export const esWB_Queue = "WB_Queue";
/**
 * Used for the WB_QUEUE_RUN_ID sequence only
 */
export const esWB_Queue_RunId = "WB_Queue_RunId";

// Connection, Dimensions, Report Tiles
export const esWB_Connection = "WB_Connection";
export const esWB_Dimension = "WB_Dimension";
export const esWB_ReportTile = "WB_ReportTile";
export const esWB_ReportTile_Dimension = "WB_ReportTile_Dimension";

// Reporting - Subject Area, Hierarchies
export const esWB_Subject_Area = "WB_SubjectArea";
export const esWB_Report_Product_Group_Hierarchy = "WB_Report_PrdGrpH";
export const esWB_Report_Customer_Hierarchy = "WB_Report_CustH";
export const esWB_Report_Time_Hierarchy = "WB_Report_TimeH";

// Workspace
export const esWB_Workspace = "WB_Workspace";
export const esWB_Workspace_Dimension = "WB_Workspace_Dimension";
export const esWB_Workspace_Report = "WB_Workspace_Report";
export const esWB_Workspace_Report_Dimension = "WB_Workspace_Report_Dimension";

// Note BO
export const esWB_Note = "WB_Note";
export const esWB_Note_User = "WB_NoteUsrR";

// Cannibalization Set
export const esWB_Cannibalization_Set = "WB_Cann";
export const esWB_Cannibalization_Set_Product_Group = "WB_CannPG";
export const esWB_Cannibalization_Set_Customer = "WB_CannCst";
export const esWB_Cannibalization_Set_Product = "WB_CannPrd";

// Power Metric
export const esWB_Power_Metric = "WB_Model_PowerMetric";
export const esWB_Power_Metric_Relationship = "WB_Model_PowerMetricR";

// Product Attribute Group BO
export const esWB_Product_Attribute_Group = "WB_PrdAtrG";
export const esWB_Product_Attribute_Group_Relationship = "WB_PrdAtrGR";

// Product Attribute Map BO
export const esWB_Product_Attribute_Map = "WB_PrdAttrMap";
export const esWB_Product_Attribute_Map_External_Relationship = "WB_PrdAttrMap_ExtR";
export const esWB_Product_Attribute_Map_Value_Relationship = "WB_PrdAttrMap_ValueR";

//SourceType
export const esWB_SourceType = "WB_SourceType";
export const esWB_SourceTypeSTR = "WB_SourceTypeSTR";

// Snapshot BO
export const esWB_Snapshot = "WB_Snapshot";
export const esWB_Snapshot_Customer_Relationship = "WB_Snapshot_CustR";
export const esWB_Snapshot_ProductGroup_Relationship = "WB_Snapshot_PrdR";
export const esWB_Snapshot_Period_Relationship = "WB_Snapshot_PeriodR";
export const esWB_Snapshot_Plan_Relationship = "WB_Snapshot_PlanR";
export const esWB_Snapshot_Param = "WB_Snapshot_Param";
export const esWB_Snapshot_ParamGLR = "WB_Snapshot_ParamGLR";
export const esWB_Snapshot_ParamGLELR = "WB_Snapshot_ParamGLELR";
export const esWB_Snapshot_ParamSAR = "WB_Snapshot_ParamSAR";
export const esWB_Snapshot_ParamAMR = "WB_Snapshot_ParamAMR";
export const esWB_Snapshot_ParamCHR = "WB_Snapshot_ParamCHR";
export const esWB_Snapshot_ParamPHR = "WB_Snapshot_ParamPHR";
export const esWB_Snapshot_ParamGLCHR = "WB_Snapshot_ParamGLCHR";
export const esWB_Snapshot_ParamGLPHR = "WB_Snapshot_ParamGLPHR";
export const esWB_Snapshot_ParamPlnR = "WB_Snapshot_ParamPlnR";
export const esWB_Snapshot_ParamETR = "WB_Snapshot_ParamETR";

// Snapshot Type BO
export const esWB_Snapshot_Type = "WB_SnapshotM";
export const esWB_Snapshot_Msar = "WB_SnapshotMSAR";

// Snapshot Metrics
export const esWB_Plan_Volume_Metrics_Snapshot = "WB_PlanVMtS";
export const esWB_Event_Spend_Metrics_Snapshot = "WB_TEvtSMtS";
export const esWB_Plan_NFP_Snapshot = "WB_PlanNFPS";

// Event Type BO
export const esWB_Event_Type = "WB_EvtType";

// Currency BO
export const esWB_Currency = "WB_Currency";
export const esWB_CurrencyT = "WB_CurrencyT";

// Exchange Rate Type BO
export const esWB_ExchangeRateM = "WB_ExchangeRateM";
export const esWB_ExchangeRateMT = "WB_ExchangeRateMT";
export const esWB_ExchangeRateMR = "WB_ExchangeRateMR";

// General Ledger BO
export const esWB_General_Ledger = "WB_GL";

// General Ledger Account BO
export const esWB_General_Ledger_Account = "WB_GLAcct";
export const esWB_General_Ledger_Account_Text = "WB_GLAcctT";

// TPM GL Policy BO
export const esWB_General_Ledger_Policy = "WB_GLRL";
export const esWB_General_Ledger_Policy_Account = "WB_GLRLAcct";

// Fund Type BO
export const esWB_Fund_Type = "WB_FundType";

// Transaction Type BO
export const esWB_Transaction_Type = "WB_TxnType";

// Transaction BO
export const esWB_Transaction = "WB_Txn";
export const esWB_Transaction_Item = "WB_TxnItem";

// GL Transaction
export const esWB_GLTransaction = "WB_GLTxn";
export const esWB_GLTransaction_Item = "WB_GLTxn_Item";

//GL Account Starting Balances
export const esWB_GLAccount_Balance = "WB_GLAcct_Bal";

//Workflow BO
export const esWB_Workflow = "WB_Workflow";
export const esWB_Workflow_Status = "WB_WorkflowStatus";
export const esWB_Status_Relationship = "WB_StatusR";

// Misc Workflow
export const esWB_Status_History = "WB_StatusH";
export const esWB_Status_History_Log = "WB_StatusHL";
export const esWB_User_Reviewers = "WB_UsrRvwr";

// Plan Type  BO
export const esWB_Plan_Type = "WB_PlanM";
export const esWB_Plan_Type_Event_Type = "WB_PlanMEvent";
export const esWB_Plan_Type_Fund_Type = "WB_PlanMFnd";

// Baseline BO
export const esWB_BaseLn = "WB_BaseLn";
export const esWB_BaseLnMt = "WB_BaseLnMt";
export const esWB_Baseline = "WB_Baseline";
export const esWB_Baseline_Metrics = "WB_BaselineMT";

// Plan Management BO
export const esWB_Plan_Management = "WB_PlanManagement";
export const esWB_Plan_Management_User = "WB_PlanManagementUserR";
export const esWB_Plan_Management_Period = "WB_PlanManagementPeriodR";
export const esWB_Plan_Management_User_Group = "WB_PlanManagementUserGroupR";

// Metric Definition
export const esWB_Metric_Definition = "WB_MetricDefinition";
export const esWB_MetricDefinition_GLAccount = "WB_MetricDefinitionGLAccount";
export const esWB_MetricDefinition_EventSpend_Type = "WB_MetricDefinitionEvtSType";

export const esWB_MetricDefinition_Component = "WB_MetricR";

// Metric View
export const esWB_Metric_View = "WB_MetricView";
export const esWB_Metric_View_Metric = "WB_MetricViewR";

// Misc
export const esWB_Timing = "WB_Timing";

// Model - Master Data
export const esWB_Model_Predictor = "WB_Model_Predictor";
export const esWB_Model_Function = "WB_Model_Function";
export const esWB_Model_Input = "WB_Model_Input";
export const esWB_Model_Volume_Component = "WB_Model_Vol_Comp";

// Model
export const esWB_Model = "WB_Model";
export const esWB_Model_Constant = "WB_Model_Constant";
export const esWB_Model_Term = "WB_Model_Term";
export const esWB_Model_Term_Relationship = "WB_Model_TermR";
export const esWB_Model_Predictor_Relationship = "WB_Model_PredictorR";
export const esWB_Model_Tag_Relationship = "WB_Model_TagR";
export const esWB_Model_Volume_ComponentR = "WB_Model_Volume_ComponentR";
export const esWB_Model_Volume_Component_ItemR = "WB_Model_Volume_Component_ItemR";
export const esWB_Model_Event_Type_Relationship = "WB_Model_EvtTypeR"

// Model Compare
export const esWB_Model_Compare = "WB_Model_Compare";
export const esWB_Model_Compare_Relationship = "WB_Model_CompareR";

// Model Simulation Profile Config
export const esWB_Model_Profile = "WB_Model_Profile";
export const esWB_Model_Profile_Predictor = "WB_Model_ProfilePR";
export const esWB_Model_Profile_Group = "WB_Model_ProfileGR";
export const esWB_Model_Profile_Group_Predictor = "WB_Model_ProfileGPR";
export const esWB_Model_Profile_Spend_Function = "WB_Model_ProfileSFR";

// Model Coefficient
export const esWB_Model_Coefficient = "WB_Model_Coefficient";

// Model Coefficient Set
export const esWB_Model_Coeff_Set = "WB_Model_Coeff_Set";
export const esWB_Model_Coeff_Set_Rule = "WB_Model_Coeff_Set_Rule";
export const esWB_Model_Coeff_SetR = "WB_Model_Coeff_SetR";
export const esWB_Model_Coeff_SetCR = "WB_Model_Coeff_SetCR";
export const esWB_Model_Coeff_SetASR = "WB_Model_Coeff_SetASR";
export const esWB_Model_Coeff_SetPMR = "WB_Model_Coeff_SetPMR";
export const esWB_Model_Coeff_SetRR = "WB_Model_Coeff_SetRR";
export const esWB_Model_Coeff_SetTR = "WB_Model_Coeff_SetTR";

//Model DataSource
export const esWB_Model_DataSource = "WB_Model_DataSource";

//Model Cannibalization
export const esWB_Model_Cannibalization_Type = "WB_Model_CannibalizationM";
export const esWB_Model_Cannibalization_Relationship = "WB_Model_CannR";
export const esWB_Model_Cannibalization_Term_Relationship = "WB_Model_CannTermR";

// Modeling Session
export const esWB_Modeling_Session = "WB_Modeling_Session";
export const esWB_Modeling_Session_Stage = "WB_Modeling_Session_Stage";
export const esWB_Modeling_Session_StageAlgorithm = "WB_Modeling_Session_StageAR";
export const esWB_Modeling_Session_StageCoeffRangePolicy = "WB_Modeling_Session_StageCRP";
export const esWB_Modeling_Session_StageCoeffRangePolicyMeta = "WB_Modeling_Session_StageCRP_Meta";
export const esWB_Modeling_Session_StageCoeffRangePolicyR = "WB_Modeling_Session_StageCRPR";
export const esWB_Modeling_Session_Range = "WB_Modeling_Session_Range";
export const esWB_Modeling_Session_CustR = "WB_Modeling_Session_CustR";
export const esWB_Modeling_Session_ProdR = "WB_Modeling_Session_ProdR";
export const esWB_Modeling_Session_Log = "WB_Modeling_Session_Log";
export const esWB_Modeling_Session_Trial = "WB_Modeling_Session_Trial";
export const esWB_Modeling_Session_Trial_Metric = "WB_Modeling_Session_TrialMt";
export const esWB_Modeling_Session_Trial_Residual_Metric = "WB_Modeling_Session_TrialRsdMt";
export const esWB_Modeling_Session_Trial_Predictor_Metric = "WB_Modeling_Session_TrialPMt";
export const esWB_Modeling_Session_Trial_PredictorR_Metric = "WB_Modeling_Session_TrialPRMt";
export const esWB_Modeling_Session_Observation = "WB_Modeling_Session_Observations";
export const esWB_Modeling_Session_Tag_RuleR = "WB_Modeling_Session_Tag_RuleR";
export const esWB_Modeling_Session_Coeff_Rule = "WB_Modeling_Session_Coeff_Rule";
export const esWB_Modeling_Session_Coeff_RuleR = "WB_Modeling_Session_Coeff_RuleR";
export const esWB_Modeling_Session_Reference_Predictor_Relationship = "WB_Modeling_Session_RefPR";
export const esWB_Modeling_Session_Reference_Relationship = "WB_Modeling_Session_RefR";
export const esWB_Modeling_Session_Cannibalization_Type_Relationship = "WB_Modeling_Session_CannMR";
export const esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship = "WB_Modeling_Session_CannPMR";
export const esWB_Modeling_Session_AffinitySet_Relationship = "WB_Modeling_Session_ASR";
export const esWB_Modeling_SessionPR = "WB_Modeling_SessionPR";
export const esWB_Modeling_Session_El = "WB_Modeling_Session_El";
export const esWB_Modeling_Session_ElR = "WB_Modeling_Session_ElR";
export const esWB_Modeling_Session_ElCR = "WB_Modeling_Session_ElCR";
export const esWB_Modeling_Session_TermR = "WB_Modeling_Session_TermR";
export const esWB_Modeling_Session_Coeff_Grp = "WB_Modeling_Session_Coeff_Grp";
export const esWB_Modeling_Session_Coeff_GrpSt = "WB_Modeling_Session_Coeff_GrpSt";
export const esWB_Modeling_Session_Coeff_GrpStR = "WB_Modeling_Session_Coeff_GrpStR";
export const esWB_Modeling_Session_ConstantR = "WB_Modeling_Session_ConstantR";
export const esWB_Modeling_Session_SeasonalityMt = "WB_Modeling_Session_SeasonalityMt";
export const esWB_Modeling_Session_Seasonality_DepMt = "WB_Modeling_Session_Seasonality_DepMt";
export const esWB_Modeling_Session_Seasonality_Coeff = "WB_Modeling_Session_Seasonality_Coeff";
export const esWB_Model_Coeff_SetConstR = "WB_Model_Coeff_SetConstR";
export const esWB_Modeling_Session_ConstantFR = "WB_Modeling_Session_ConstantFR";

// Modeling Session Monitor
export const esWB_Modeling_Session_Trial_PartitionStage = "WB_Modeling_Session_TrialPS";
export const esWB_Modeling_Session_Trial_PartitionStageS = "WB_Modeling_Session_TrialPSS";
export const esWB_Modeling_Session_Trial_PartitionStageSL = "WB_Modeling_Session_TrialPSSL";

//Published Model
export const esWB_Published_Model = "WB_Published_Model";

// Loader BO
export const esWB_Loader = "WB_Loader";
export const esWB_Loader_KeyMap = "WB_Loader_KeyMap";
export const esWB_Loader_MetricMap = "WB_Loader_MetricMap";
export const esWB_Loader_MetricTerm = "WB_Loader_MetricTerm";
export const esWB_Loader_Operation = "WB_Loader_Operation";
export const esWB_Loader_Source = "WB_Loader_Source";

//Report
export const esWB_Report = "WB_Report";
export const esWB_Report_Metric = "WB_Report_MetricR";
export const esWB_Report_Export = "WB_Report_Export";

//Promotion Simulator
export const esWB_Simulation_Input = "WB_Simulation_Input";
export const esWB_Simulation_Input_Relationship = "WB_Simulation_InputR";

export const esWB_Simulation = "WB_Simulation";
export const esWB_Simulation_Relationship = "WB_Simulation_SR";
export const esWB_Simulation_Product = "WB_Simulation_Prd";
export const esWB_Simulation_Predictor_Relationship = "WB_Simulation_PredictorR";

export const esWB_ScnPlan = "WB_ScnPlan";
export const esWB_ScnPlan_EvtTypeR = "WB_ScnPlan_EvtTypeR";
export const esWB_ScnPlan_CustR = "WB_ScnPlan_CustR";
export const esWB_ScnPlan_PrdR = "WB_ScnPlan_PrdR";
export const esWB_ScnPlan_PredictorR = "WB_ScnPlan_PredictorR";
export const esWB_ScnPlan_InputR = "WB_ScnPlan_InputR";
export const esWB_ScnPlan_CoeffR = "WB_ScnPlan_CoeffR";

export const esWB_ScnPlanner = "WB_ScnPlanner";
export const esWB_ScnPlannerCalc = "WB_ScnPlannerCalc"
export const esWB_ScnPlannerCalcLog = "WB_ScnPlannerCalcLog"
export const esWB_ScnPlannerCnstr = "WB_ScnPlannerCnstr"
export const esWB_ScnPlannerCR = "WB_ScnPlannerCR"
export const esWB_ScnPlannerESR = "WB_ScnPlannerESR"
export const esWB_ScnPlannerPPR = "WB_ScnPlannerPPR"
export const esWB_ScnPlannerPR = "WB_ScnPlannerPR"
export const esWB_ScnPlannerPrdPPR = "WB_ScnPlannerPrdPPR"
export const esWB_ScnPlannerPrdPR = "WB_ScnPlannerPrdPR"
export const esWB_ScnPlannerTrial = "WB_ScnPlannerTrial"
export const esWB_ScnPlannerTrialPR = "WB_ScnPlannerTrialPR"
export const esWB_ScnPlannerTrialCNR = "WB_ScnPlannerTrialCNR"

export const esWB_ScnPlannerTrialEvt = "WB_ScnPlannerTrialEvt"

export const esWB_ScnConstraint = "WB_ScnConstraint"

export const esWB_Model_API_Log = "WB_Model_API_Log";

//Constraint Based Optimizer
export const esWB_CBO = "WB_CBO";
export const esWB_CBO_Input_Relationship = "WB_CBO_InputR";
export const esWB_CBO_Constraint = "WB_CBO_Constraint";
export const esWB_CBO_Set = "WB_CBO_Set";
export const esWB_CBO_Set_Item = "WB_CBO_Set_Item";
export const esWB_CBO_Set_Predictor = "WB_CBO_Set_Predictor";

export const esWB_Spend_Function = "WB_Spend_Function";
export const esWB_Spend_Function_Input_Relationship = "WB_Spend_Function_InputR";
export const esWB_Spend_Function_Term_Relationship = "WB_Spend_Function_TermR";

// Simulation Financial Model
export const esWB_Spend_Function_Relationship = "WB_Spend_FunctionR";
export const esWB_Spend_Function_Relationship_Scope = "WB_Spend_FunctionCPR";

// Simulation/CBO/Demand Simulation Metrics
export const esWB_Simulation_Metrics = "WB_SimMt";
export const esWB_Simulation_Metrics_CBO_Set = "WB_SimMtSR";
export const esWB_Simulation_Spend_Metrics = "WB_SimSMt";

//UI Framework
export const esWB_UI_Profile = "WB_UI_Profile";
export const esWB_UI_AppSuite_Type = "WB_UI_AppSuiteM";
export const esWB_UI_AppSuite = "WB_UI_AppSuite";
export const esWB_UI_Application = "WB_UI_App";
export const esWB_UI_AppModule = "WB_UI_AppModule";
export const esWB_UI_AppSuite_App_Relationship = "WB_UI_AppSuiteAR";
export const esWB_UI_App_Report = "WB_UI_App_Report";
export const esWB_UI_AppExecutable = "WB_UI_AppExec";
export const esWB_UI_Usage = "WB_UI_Usage";

export const esWB_Tree = "WB_Tree";
export const esWB_Tree_Folder = "WB_Tree_Folder";

// License BO
export const esWB_License = "WB_License";

// Benchmark BO
export const esWB_Benchmark = "WB_Benchmark";

// Model Engine
// export const esWB_Model_ID = "WB_Model";
// export const esWB_Model_Coefficient_Run_ID = "WB_Coefficient_Run";

// Control Points
export const esWB_Partition = "WB_Partition";
export const esWB_PartitionR = "WB_PartitionR";

// Control Points
export const esWB_ControlPoint_Type = "WB_ControlPointM";
export const esWB_ControlPoint_Type_Process = "WB_ControlPointMPR";
export const esWB_ControlPoint_Type_Process_Input = "WB_ControlPointMPIR";

export const esWB_ControlPoint = "WB_ControlPoint";
export const esWB_ControlPoint_Partition = "WB_ControlPointPR";
export const esWB_ControlPoint_Partition_Input = "WB_ControlPointPIR";

// Classification
export const esWB_Classification = "WB_Classification";
export const esWB_Classification_Step = "WB_Classification_Step";
export const esWB_Classification_StepR = "WB_Classification_StepR";
export const esWB_Classification_Control = "WB_Classification_Control";
export const esWB_Classification_Control_Partition = "WB_Classification_ControlPR";

// LE Spend
export const esWB_LE_Spend = "WB_LE_Spend";
export const esWB_LE_Spend_Partition = "WB_LE_SpendPR";
export const esWB_LE_Spend_Partition_Input = "WB_LE_SpendPSR";

// Spend Actualization
export const esWB_Act_Spend = "WB_Act_Spend";
export const esWB_Act_Spend_Partition = "WB_Act_SpendPR";
export const esWB_Act_Spend_Partition_Input = "WB_Act_SpendPSR";

// Schedule
export const esWB_Schedule = "WB_Schedule";

///Lift Calculations
export const esWB_LiftAPI = "WB_LiftAPI";

///Search
export const esWB_Search = "WB_Search";
export const esWB_Search_Profile = "WB_Search_Profile";
export const esWB_Search_ProfileCR = "WB_Search_ProfileCR";
export const esWB_Search_ProfileFCR = "WB_Search_ProfileFCR";
export const esWB_Search_ProfileGCR = "WB_Search_ProfileGCR";

//Hierarchy Builder
export const esWB_Hierarchy = "WB_Hierarchy";
export const esWB_Hierarchy_Level = "WB_HierarchyLR";
export const esWB_Hierarchy_SalesArea = "WB_HierarchySR";
export const esWB_Hierarchy_Period = "WB_HierarchyMPR";
export const esWB_Hierarchy_Entity_Generation = "WB_HierarchyEGR";
export const esWB_Hierarchy_Attribute_Generation = "WB_HierarchyAGR";
export const esWB_Hierarchy_Intelligent_Key = "WB_HierarchyIKR";
export const esWB_Hierarchy_Export = "WB_Hierarchy_Export";
export const esWB_Hierarchy_MDScope = "WB_Hierarchy_MDScope";

//Pricing Policy
export const esWB_PolicyArea = "WB_PolicyArea";
export const esWB_Policy_Term_Type = "WB_PolicyTermM";
export const esWB_Policy = "WB_Policy";
export const esWB_Policy_Term = "WB_PolicyTerm";

export const esWB_Policy_SalesArea = "WB_PolicySAR";
export const esWB_Policy_Procedure = "WB_PolicyPLR";
export const esWB_Policy_Cube = "WB_PolicyCube";
export const esWB_Policy_Cube_TermR = "WB_PolicyCubeTR";
export const esWB_Policy_Cube_Process = "WB_PolicyCubeProcess";
export const esWB_Policy_Cube_ProcessR = "WB_PolicyCubeProcessR";
export const esWB_Policy_SpendType_TermR = "WB_PolicySpendTypeTermR";
export const esWB_Policy_Term_Value = "WB_PolicyTermValue";

export const esWB_DataMart = "WB_DataMart";
export const esWB_DataMart_Plan_Relationship = "WB_DataMartPlnR";

// Event Volume Assignment
export const esWB_EvtVolume = "WB_EvtVolume";
export const esWB_EvtVolumePR = "WB_EvtVolumePR";

// Volume Decomposition
export const esWB_VolDecomp = "WB_Vol_Decomp";
export const esWB_VolDecompPR = "WB_Vol_DecompPR";
export const esWB_VolDecompPR_BS_Default = "WB_Vol_DecompPR_BS_Default";
export const esWB_VolDecompPR_BS_Detail = "WB_Vol_DecompPR_BS_Detail";
export const esWB_VolDecompPR_EDLP_Default = "WB_Vol_DecompPR_EDLP_Default";
export const esWB_VolDecompPR_EDLP_Detail = "WB_Vol_DecompPR_EDLP_Detail";
export const esWB_VolDecompPR_Merch_Default = "WB_Vol_DecompPR_Merch_Default";
export const esWB_VolDecompPR_PassThrough_Default = "WB_Vol_DecompPR_PassThrough_Default";

// PPA
export const esWB_PPA_Model = "WB_PPA_Model"
export const esWB_PPA_Manufacturer = "WB_PPA_Manufacturer"
export const esWB_PPA_Market = "WB_PPA_Market"
export const esWB_PPA_Channel = "WB_PPA_Channel"
export const esWB_PPA_Brand = "WB_PPA_Brand"
export const esWB_PPA_SubBrand = "WB_PPA_SubBrand"
export const esWB_PPA_Attribute = "WB_PPA_Attribute"
export const esWB_PPA_Attribute_Level = "WB_PPA_Attribute_Level"
export const esWB_PPA_PricePrdType = "WB_PPA_PricePrdType"
export const esWB_PPA_PricePrdType_Level = "WB_PPA_PricePrdType_Level"
export const esWB_PPA_Product = "WB_PPA_Product"
export const esWB_PPA_Product_Attribute = "WB_PPA_Product_Attribute"
export const esWB_PPA_Consumer_Segment = "WB_PPA_Consumer_Segment"
export const esWB_PPA_Respondent = "WB_PPA_Respondent"
export const esWB_PPA_Adjustment = "WB_PPA_Adjustment"
export const esWB_PPA_Condition = "WB_PPA_Condition"
export const esWB_PPA_Market_Share = "WB_PPA_Market_Share"
export const esWB_PPA_PricePrdType_Coeff = "WB_PPA_PricePrdType_Coeff"
export const esWB_PPA_Scenario = "WB_PPA_Scenario"
export const esWB_PPA_Scenario_Prd = "WB_PPA_Scenario_Prd"
export const esWB_PPA_Market_CSR = "WB_PPA_Market_CSR"
export const esWB_PPA_Market_CSRR = "WB_PPA_Market_CSRR"
export const esWB_PPA_Respondent_Utility = "WB_PPA_Respondent_Utility"
export const esWB_PPA_PriceLevel = "WB_PPA_PriceLevel"

//FC Overrides
export const esWB_FC_Override = "WB_FC_Override"
export const esWB_FC_Override_Log = "WB_FC_Override_Log"
export const esWB_FC_Override_Event_Volume = "WB_FC_Override_Event_Volume"
export const esWB_FC_Override_Event_Spend = "WB_FC_Override_Event_Spend"
export const esWB_FC_Override_Event_Date = "WB_FC_Override_Event_Date"
export const esWB_FC_Override_Event_Merge = "WB_FC_Override_Event_Merge"
export const esWB_FC_Override_Event_MergeR = "WB_FC_Override_Event_MergeR"
export const esWB_FC_Override_Event_Source_Customer = "WB_FC_Override_Event_Source_Customer"
export const esWB_FC_Override_Event_Spend_Redistribution = "WB_FC_Override_Event_Spend_Redistribution"
export const esWB_FC_Override_Event_Spend_RedistributionR = "WB_FC_Override_Event_Spend_RedistributionR"
export const esWB_FC_Override_Event_Product = "WB_FC_Override_Event_Product"
export const esWB_FC_Override_Customer = "WB_FC_Override_Customer"
export const esWB_FC_Override_Product = "WB_FC_Override_Product"
export const esWB_FC_Override_Consumption = "WB_FC_Override_Consumption"

// Reference by mapper

export const dctSchemaByEntitySet: { [id: string]: Schema } = {};

// These tables need to be moved into the JSData Schemas
export const dctTableNameByEntitySet: { [id: string]: string } = {};

// Logical keys for metadata export
export const dctLogicalKeysByEntitySet: { [id: string]: string[] } = {};

//maps tables to foreign keys that aren't part of JSDataRels for dataexporter/importer
export const dctNonParentForeignKeysByEntitySet: { [id: string]: { [columnName: string]: string } } = {};

export const KeyGenSpecs_default = { start_value: 1, max_value: 2147483647, keyPoolSize: 10, incrementSize: 1 };
export const KeyGenSpecs_Poolsize_50 = { start_value: 1, max_value: 2147483647, keyPoolSize: 50, incrementSize: 1 };
export const KeyGenSpecs_Poolsize_200 = { start_value: 1, max_value: 2147483647, keyPoolSize: 200, incrementSize: 1 };
export const KeyGenSpecs_Poolsize_250 = { start_value: 1, max_value: 2147483647, keyPoolSize: 250, incrementSize: 1 };
export const KeyGenSpecs_Poolsize_500 = { start_value: 1, max_value: 2147483647, keyPoolSize: 500, incrementSize: 1 };
export const KeyGenSpecs_Poolsize_2000 = { start_value: 1, max_value: 2147483647, keyPoolSize: 2000, incrementSize: 1 };

const bigIntMax = BigInt("9223372036854775807");
export const KeyGenSpecs_BigInt_default = { start_value: 1, max_value: bigIntMax, keyPoolSize: 10, incrementSize: 1 };
export const KeyGenSpecs_BigInt_PoolSize_50 = {
    start_value: 1,
    max_value: bigIntMax,
    keyPoolSize: 50,
    incrementSize: 1
};
export const KeyGenSpecs_BigInt_PoolSize_200 = {
    start_value: 1,
    max_value: bigIntMax,
    keyPoolSize: 200,
    incrementSize: 1
};
export const KeyGenSpecs_BigInt_PoolSize_250 = {
    start_value: 1,
    max_value: bigIntMax,
    keyPoolSize: 250,
    incrementSize: 1
};
export const KeyGenSpecs_BigInt_PoolSize_500 = {
    start_value: 1,
    max_value: bigIntMax,
    keyPoolSize: 500,
    incrementSize: 1
};
export const KeyGenSpecs_BigInt_PoolSize_2000 = {
    start_value: 1,
    max_value: bigIntMax,
    keyPoolSize: 20000,
    incrementSize: 1
};

// Put schemas in other files
export const dctMapperToKeyGenSpecs: { [mapper_name: string]: IKeyGeneratorSpecs } = {};

let bCustomColumnsSetup = false;

export function PAdbSchema_addCustomColumns(): void {
    const arrCustomColumns: TableCustomColumnsEntry[] = PAEnvironment.getValue(PAEnvironment.ESCustomColumns, []);
    if (_.isEmpty(arrCustomColumns)) return;

    if (bCustomColumnsSetup) return;

    bCustomColumnsSetup = true;

    const esNameByTableName: { [tableName: string]: string } = {};
    _.forEach(dctTableNameByEntitySet, (tableName, esName) => {
        esNameByTableName[tableName] = esName;
    });

    _.forEach(arrCustomColumns, (entry: TableCustomColumnsEntry) => {
        if (!(entry.name in esNameByTableName)) {
            console.log("Mapper not known for custom column  table: ", entry.name);
            return;
        }

        const esName = esNameByTableName[entry.name];
        if (!(esName in dctSchemaByEntitySet)) {
            console.log("Schema not known for custom column  table: ", entry.name);
            return;
        }
        const schema = dctSchemaByEntitySet[esName];
        _.forEach(entry.properties, (property, columnName) => {
            schema.properties[columnName] = new Schema(property);
        });
    });
}
